// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__Inter_c3f87e', '__Inter_Fallback_c3f87e'","fontStyle":"normal"},"className":"__className_c3f87e","variable":"__variable_c3f87e"};